var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frn",class:{ 'frn--compact': _vm.compact },attrs:{"data-test":"feature-request-note"}},[_c('span',{staticClass:"frn__tag"},[_vm._v(_vm._s(_vm.tag))]),_c('span',{staticClass:"frn__text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }